const DEFAULT_OPACITY = 200;
const DEFAULT_FILL_COLOR = 'rgba(45, 185, 65, 1)';
const DEFAULT_STROKE_COLOR = 'rgba(0, 0, 0, 1)';
const TIP_BAR_HEIGHT = 25;
const CURRENT_VERSION = 2;

export { DEFAULT_OPACITY, DEFAULT_FILL_COLOR, DEFAULT_STROKE_COLOR, TIP_BAR_HEIGHT, CURRENT_VERSION };
